import React from "react";
import { Link } from "react-router-dom";
import { DISCLAIMER_TEXT } from "@/lib/constants";
import { useLang } from "@/context/LangContext";
import BrandMark from "@/components/BrandMark";

export default function Footer() {
  const { t } = useLang();
  return (
    <footer className="border-t border-border/60 mt-20">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-12 grid gap-10 md:grid-cols-4">
        <div className="md:col-span-2">
          <BrandMark size={120} />
          <p className="text-xs uppercase tracking-[0.2em] text-muted-foreground mt-2">
            {t("footer.brand_subtitle")}
          </p>
          <p className="mt-4 text-sm text-muted-foreground leading-relaxed max-w-md">
            {t("footer.about")}
          </p>
        </div>
        <div>
          <h4 className="text-sm font-semibold mb-3">{t("footer.platform")}</h4>
          <ul className="space-y-2 text-sm text-muted-foreground">
            <li><Link to="/cities" className="hover:text-foreground" data-testid="footer-cities">{t("nav.cities")}</Link></li>
            <li><Link to="/categories" className="hover:text-foreground" data-testid="footer-categories">{t("nav.categories")}</Link></li>
            <li><Link to="/vendors" className="hover:text-foreground" data-testid="footer-vendors">{t("footer.all_vendors")}</Link></li>
            <li><Link to="/contact" className="hover:text-foreground" data-testid="footer-contact">{t("footer.contact")}</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="text-sm font-semibold mb-3">{t("footer.legal")}</h4>
          <ul className="space-y-2 text-sm text-muted-foreground">
            <li><Link to="/terms" className="hover:text-foreground" data-testid="footer-terms">{t("footer.terms")}</Link></li>
            <li><Link to="/privacy" className="hover:text-foreground" data-testid="footer-privacy">{t("footer.privacy")}</Link></li>
            <li><Link to="/disclaimer" className="hover:text-foreground" data-testid="footer-disclaimer">{t("footer.disclaimer")}</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-border/60 py-6 px-4 sm:px-6 lg:px-8">
        <div className="mx-auto max-w-7xl">
          <div className="rounded-2xl border border-border/60 bg-card/60 p-5 sm:p-6" data-testid="footer-disclaimer-text">
            <div className="text-xs uppercase tracking-[0.2em] text-primary mb-2">{t("footer.disclaimer")}</div>
            <p className="text-sm sm:text-base leading-relaxed text-foreground/80">
              {DISCLAIMER_TEXT}
            </p>
          </div>
          <p className="mt-4 text-xs text-muted-foreground">
            © {new Date().getFullYear()} sanskariBazarIn. {t("footer.rights")}
          </p>
        </div>
      </div>
    </footer>
  );
}
